import { createElement } from "@wordpress/element";
/**
 * Internal dependencies
 */
import { PointerCircle } from './styles/focal-point-style';

/**
 * External dependencies
 */
import classnames from 'classnames';
export default function FocalPoint({
  left = '50%',
  top = '50%',
  ...props
}) {
  const classes = classnames('components-focal-point-picker__icon_container');
  const style = {
    left,
    top
  };
  return createElement(PointerCircle, {
    ...props,
    className: classes,
    style: style
  });
}
//# sourceMappingURL=focal-point.js.map